import i18n from 'modules/core/lib/i18n'

type BuildInsightsPromptParams = {
  postId: string
  title?: string | null
  communityTitle?: string | null
  hasRequiredActions: boolean
}

export const buildInsightsPrompt = ({
  postId,
  title,
  communityTitle,
  hasRequiredActions,
}: BuildInsightsPromptParams): string => {
  const safeTitle = JSON.stringify(title || `Post #${postId}`)
  const safeCommunity = JSON.stringify(communityTitle ?? '')

  return hasRequiredActions
    ? i18n.t('posts.communities.insights.one_prompt_with_actions', {
        title: safeTitle,
        community: safeCommunity,
      })
    : i18n.t('posts.communities.insights.one_prompt_without_actions', {
        title: safeTitle,
        community: safeCommunity,
      })
}
